<template>
    <AppModal ref="modal" :title="$t('calculateProductsCountModal.title')">
        <div class="modal-body">
            <template v-if="fetchTask.state.isRunning">
                <TaskProgressBar :done="fetchTask.state.done" :total="fetchTask.state.total"/>
            </template>
            <template v-else-if="deleteTask.state.isRunning">
                <TaskProgressBar :done="deleteTask.state.done" :total="deleteTask.state.total"/>
            </template>
            <template v-else>
                <div class="mb-3">
                    <AppButton color="light" @click="deleteSelectedFilters" :disabled="selectedFilters.length === 0">
                        {{ $t('buttons.delete') }}
                    </AppButton>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th width="60px">
                                    <AppCheckbox
                                        :model-value="allFiltersSelected"
                                        @update:model-value="selectAllFilters"
                                    />
                                </th>
                                <th :style="{'min-width': '150px'}">{{ $t('calculateProductsCountModal.tableHeaders.filterName') }}</th>
                                <th :style="{'min-width': '150px'}">{{ $t('calculateProductsCountModal.tableHeaders.productsCount') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="filter in filters">
                                <td>
                                    <AppCheckbox 
                                        :model-value="selectedFilters.includes(filter.uuid)"
                                        @update:model-value="selectFilter(filter.uuid)"
                                    />
                                </td>
                                <td>{{ filter.name }}</td>
                                <td>
                                    <div class="d-flex justify-content-end ">
                                        {{ filter.productsCount }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../../components/new/progress/TaskProgressBar.vue';
import AppCheckbox from '../../../../../../components/new/form/checkbox/AppCheckbox.vue';

import { httpClient } from '../../../../../../services/HttpClient';
import { createProgressTask } from '../../../../../../services/Progress/ProgressTask';

export default {
    name: "CalculateProductsCountModal",
    components: {
        AppModal, AppButton, TaskProgressBar, AppCheckbox
    },
    emits: ['filters:deleted'],
    data() {
        return {
            fetchTask: createProgressTask(),
            deleteTask: createProgressTask(),
            filters: [],
            selectedFilters: []
        }
    },
    methods: {
        show(filterUuids) {
            this.$refs.modal.show();

            this.fetchTask.run(async (progress) => {
                await this.fetchFilters(filterUuids, progress);
            });
        },
        hide() {
            this.fetchTask.cancel();
            this.deleteTask.cancel();
            this.$refs.modal.hide();
            this.filters = [];
            this.selectedFilters = [];
        },
        async fetchFilters(filterUuids, {tick}) {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters`, {
                extra_fields: ['productsCount'],
                uuids: filterUuids,
                orders: [{
                    column: 'integration_product_items_count',
                    dir: 'desc'
                }],
                limit: 100
            }).then((response) => {
                this.filters = response.data.data.map((filter) => {
                    tick();
                    return {
                        uuid: filter.uuid,
                        name: filter.name,
                        productsCount: filter.integration_product_items_count
                    }
                })
            })
        },
        selectAllFilters() {
            if (this.allFiltersSelected) {
                this.selectedFilters = [];
                return;
            }

            this.selectedFilters = this.filters.map(filter => filter.uuid);
        },
        selectFilter(filterUuid) {
            if (this.selectedFilters.includes(filterUuid)) {
                this.selectedFilters = this.selectedFilters.filter(uuid => uuid !== filterUuid);
                return;
            }

            this.selectedFilters.push(filterUuid);
        },
        async deleteSelectedFilters() {
            const completed = await this.deleteTask.run(async ({signal, setTotal, tick}) => {
                setTotal(this.selectedFilters.length);

                for (const filterUuid of this.selectedFilters) {
                    if (signal.aborted) {
                        break;
                    }

                    await httpClient.delete(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters/${filterUuid}`);
                    tick();
                }
            });

            if (completed) {
                this.hide();
                this.$emit('filters:deleted');
            }
        }
    },
    computed: {
        allFiltersSelected() {
            return this.selectedFilters.length === this.filters.length;
        }
    },
    beforeUnmount() {
        this.fetchTask.cancel();
        this.deleteTask.cancel();
    }
}
</script>